import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css'; // Assuming your CSS file

const CoverImageFive = () => {
    const navigate = useNavigate(); // Initialize navigate

    return (
        <div className="package-heading1">
            <h1>Our Packages</h1>
            <p>
                Our offerings ensure that you create lasting memories while enjoying quality time together. Below, you'll find detailed information about our thoughtfully crafted packages, along with our mouthwatering menu options tailored to enhance your experience. Dive into our offerings for a delightful day!
            </p>

            <div className="package-reservation">
                <button className="reservations-button" onClick={() => navigate('/contact')}>
                    <p className="image-gallery1-heading2">Make Your Reservation....</p>
                </button>
            </div>

            <div className="package-container1">
                <table className="package-table1">
                    <tbody>
                        <tr>
                            <td className="package-content1">
                                <div className="package-content-text1">
                                    <h2>Cocoloco Package Details</h2>
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td className="cover-package1">
                                <div className="image-gallery1-package">
                                    <div className="gallery-item">
                                        <p className="image-gallery1-heading">DAY OUTING AT COCOLOCO</p>
                                        <button
                                            className="image-gallery1-button"
                                            onClick={() => navigate('/dayouting')} // Use navigate here
                                        >
                                            <img
                                                src="/package/pack-dayout.webp"
                                               
                                                className="gallery-image1-package"
                                            />
                                            <p className="image-gallery1-heading3">View More Details.....</p>
                                        </button>
                                    </div>

                                     <div className="gallery-item">
                                                                            <p className="image-gallery1-heading">SPEND THE NIGHT AT COCOLOCO</p>
                                                                            <button
                                                                                className="image-gallery1-button"
                                                                                onClick={() => navigate('/dayouting')} // Use navigate here
                                                                            >
                                                                                <img
                                                                                    src="/package/nightpack.jpeg"

                                                                                    className="gallery-image1-package"
                                                                                />
                                                                                <p className="image-gallery1-heading3">View More Details.....</p>
                                                                            </button>
                                                                        </div>

                                    {/*<div className="gallery-item">
                                        <p className="image-gallery1-heading">SPECIALEVENT PACKAGE</p>
                                        <button
                                            className="image-gallery1-button"
                                            onClick={() => navigate('/special')} // Use navigate here
                                        >
                                            <img
                                                src="/package/packenveryevent.webp"
                                               
                                                className="gallery-image1-package"
                                            />
                                            <p className="image-gallery1-heading3">View More Details.....</p>
                                        </button>
                                    </div>*/}

                                    <div className="gallery-item">
                                        <p className="image-gallery1-heading">AVRUDU PACKAGE</p>
                                        <button
                                            className="image-gallery1-button"
                                            onClick={() => navigate('/awrudhu')} // Use navigate here
                                        >
                                            <img
                                                src="/package/packawrudu.webp"
                                               
                                                className="gallery-image1-package"
                                            />
                                            <p className="image-gallery1-heading3">View More Details.....</p>
                                        </button>
                                    </div>

                                   {/* <div className="gallery-item">
                                        <p className="image-gallery1-heading">WEDDING PACKAGE</p>
                                        <button
                                            className="image-gallery1-button"
                                            onClick={() => navigate('/wedding')} // Use navigate here
                                        >
                                            <img
                                                src="/package/packwedd.webp"
                                               
                                                className="gallery-image1-package"
                                            />
                                            <p className="image-gallery1-heading3">View More Details.....</p>
                                        </button>
                                    </div>*/}

                                    {/*<div className="gallery-item">
                                        <p className="image-gallery1-heading">ACCOMMODATION PACKAGE</p>
                                        <button
                                            className="image-gallery1-button"
                                            onClick={() => navigate('/accomadation')} // Use navigate here
                                        >
                                            <img
                                                src="/package/packroom.webp"
                                                
                                                className="gallery-image1-package"
                                            />
                                            <p className="image-gallery1-heading3">View More Details.....</p>
                                        </button>
                                    </div>*/}

                                   {/* <div className="gallery-item">
                                        <p className="image-gallery1-heading">BRING YOUR OWN CATERING PACKAGE</p>
                                        <button
                                            className="image-gallery1-button"
                                            onClick={() => navigate('/byoc')} // Use navigate here
                                        >
                                            <img
                                                src="/package/packbyoc.webp"
                                               
                                                className="gallery-image1-package"
                                            />
                                            <p className="image-gallery1-heading3">View More Details.....</p>
                                        </button>
                                    </div>*/}

                                    <div className="gallery-item">
                                        <p className="image-gallery1-heading">PHOTO SHOOT PACKAGE</p>
                                        <button
                                            className="image-gallery1-button"
                                            onClick={() => navigate('/preshoot')} // Use navigate here
                                        >
                                            <img
                                                src="/package/packphotoshoot.webp"
                                              
                                                className="gallery-image1-package"
                                            />
                                            <p className="image-gallery1-heading3">View More Details.....</p>
                                        </button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default CoverImageFive;
